import useMageXStore from "@app/zustand/store";
import useUser from "@app/zustand/user";
import { usePreviewView } from "@app/zustand/preview-view";
import { useIsReviewer } from "@app/utils/use-is-reviewer";
import type { PathwayPractitioner } from "@app/types/dashboard-pathway";

/**
 * Whether this session may narrow the dashboard to one practitioner: admins and MAGE-X's reviewers (PT-111).
 *
 * On the account the session is SHOWN as, as the server decides it: an admin previewing a médecin
 * reads that médecin's pool and has no colleague in it to narrow to — unless that médecin is a
 * reviewer, whose pool is the whole speciality and who has the filter.
 */
export function useCanFilterByPractitioner(): boolean {
  const user = useUser((state) => state.user);
  const previewRole = usePreviewView((state) => state.previewRole);
  const isReviewer = useIsReviewer();
  const role = previewRole ?? (user as { role?: string } | null)?.role;
  return role === "admin" || isReviewer;
}

/** The practitioner in force, or null — never a stored one this session may not apply. */
export function usePractitionerFilter(): PathwayPractitioner | null {
  const allowed = useCanFilterByPractitioner();
  const practitioner = useMageXStore((state) => state.practitionerFilter);
  return allowed ? practitioner : null;
}
